const paginationParams = {
  serializeQueryArgs: ({ endpointName }) => {
    return endpointName;
  },
  merge: (current, newData) => {
    if (current?.data?.paginationKey && newData.data && current?.data?.paginationKey !== newData?.data?.paginationKey) {
      current.data.items.push(...newData.data.items);
      current.data.paginationKey = newData?.data?.paginationKey;
    }
  },
  forceRefetch({ currentArg, previousArg }) {
    return currentArg !== previousArg;
  }
};

export default paginationParams;
